module.exports = __webpack_public_path__ + "img/f36.9755d689.png";